import styled from "styled-components";
import {
  ModalContainer as GlobalModalContainer,
  ModalContent as GlobalModalContent,
  ModalBody as GlobalModalBody,
} from "../../../../shared/styles/global.styles";
import { TableContainer as GlobalTableContainer } from "../../../../components/Table/styles";
import { Colors } from "../../../../shared/colors/colors";

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;
export const ContainerButtons = styled.div`
  /* margin-bottom: 16px; */
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const DateInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const InputContainer = styled.div`
  width: 100%;
`;


export const LoadingContainer = styled.div`
display: flex;
justify - content: center;
align - items: center;
height: 35vh;
width: 90vw;
`;

// Componentes de modal personalizados com menos padding nas laterais
// export const ModalContainer = styled(GlobalModalContainer)`
//   // Mantém as mesmas propriedades do componente global
//   `;

// export const ModalContent = styled(GlobalModalContent)`
// padding: 64px 32px; // Reduzido de 64px para 32px nos lados
// max - width: 85 %; // Limita a largura máxima
// width: 1100px; // Define uma largura fixa menor que o padrão
// box - shadow: 0 4px 10px rgba(0, 0, 0, 0.1); // Adiciona sombra para melhor aparência
// `;

// export const ModalBody = styled(GlobalModalBody)`
// padding: 32px 20px; // Reduzido de 32px para 20px nos lados
// overflow - x: hidden; // Previne rolagem horizontal no corpo do modal
// `;

// Container de tabela personalizado para o ModalDetalhes
export const CustomTableContainer = styled(GlobalTableContainer)`
width: 100 %;
overflow - x: auto; // Adiciona rolagem horizontal quando necessário
max - width: 100 %; // Garante que a tabela não ultrapasse o modal
margin - bottom: 1rem;
border - radius: 4px;

  // Esconde a barra de rolagem no Chrome, Safari e Opera
  &:: -webkit - scrollbar {
  height: 8px;
}

  &:: -webkit - scrollbar - track {
  background: #f1f1f1;
  border - radius: 4px;
}

  &:: -webkit - scrollbar - thumb {
  background: #888;
  border - radius: 4px;
}

  &:: -webkit - scrollbar - thumb:hover {
  background: #555;
}

  table {
  width: 100 %;
  min - width: 800px; // Tamanho mínimo para mostrar a rolagem
  table - layout: auto; // Permite que as colunas se ajustem ao conteúdo
}

  th {
  white - space: nowrap; // Evita quebra de linha nos cabeçalhos
  font - weight: 600;
}

  td {
  word - wrap: break-word; // Quebra palavras longas
  max - width: 200px; // Limita a largura máxima das células
  overflow: hidden;
  text - overflow: ellipsis; // Adiciona "..." quando o texto não cabe
}
`;
export const BlueStrong = styled.strong`
  color: ${Colors.primary};
  font-weight: 600;
  font-size: 16px;
`;


